module.exports = __webpack_public_path__ + "static/img/bg2@2x.eeddb05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/bg2@2x.png
// module id = /t5+
// module chunks = 2